export enum EFeedType {
  PRO = 'PRO',
  LITE = 'LITE',
  API = 'API',
}
